import AuthenticatedResource from 'resources/AuthenticatedResource';

export default class OrganizationAccountResource extends AuthenticatedResource {
  static urlRoot = '/organization/:organization/organization_account';

  pk() {
    return 'organizationAccount';
  }
}
